// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__vEQMD","cardTitle":"ActiveCustomers_cardTitle__TbP6g","chart":"ActiveCustomers_chart__UcJAM"};